import { EcardDesignEditor } from './EcardDesignEditor';
export default EcardDesignEditor;
